import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from "gatsby-plugin-image";
import { Container } from './container'
import { Row } from './row'
import { Col } from './col'
import { Box } from './box'
import { WrapperStyled, WrapperBgStyled } from './wrapper.style'

const Section = ({ children, tag, ...props }) => {
    const { fullwidth, bgImage, ...wrapperStyle } = props;

    if (bgImage) {
        const objectFit = wrapperStyle.objectFit || (wrapperStyle.bgsize === 'auto' ? 'none' : wrapperStyle.bgsize) || 'cover';
        const objectPosition = wrapperStyle.objectPosition || wrapperStyle.bgposition || 'center';

        return (
            <WrapperBgStyled
                {...wrapperStyle}
                as={tag}
            >
                <GatsbyImage
                    image={bgImage}
                    alt=""
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                    imgStyle={{ objectFit, objectPosition }}
                />
                <Container fluid={fullwidth} style={{ position: 'relative', zIndex: 1 }}>
                    {children}
                </Container>
            </WrapperBgStyled>
        )
    }
    return (
        <WrapperStyled as={tag} {...wrapperStyle}>
            <Container fluid={fullwidth}>
                {children}
            </Container>
        </WrapperStyled>
    )
}

export { Container, Row, Col, Box };

Section.propTypes = {
    children: PropTypes.node.isRequired,
    fullwidth: PropTypes.bool,
    pt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    pb: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    pl: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    pr: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    mt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    mb: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    ml: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    mr: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    responsive: PropTypes.object
}


export default Section;